// extracted by css-extract-rspack-plugin
export default {"watch-button":"PatslT","watchButton":"PatslT","watch-button-wrapper":"OFFvDK","watchButtonWrapper":"OFFvDK"};